import { render, staticRenderFns } from "./WorkTaskCloseDialog.vue?vue&type=template&id=5752713c"
import script from "./WorkTaskCloseDialog.vue?vue&type=script&lang=ts"
export * from "./WorkTaskCloseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports